import {library} from "@fortawesome/fontawesome-svg-core";

//REGULAR
import { faFile, faPodcast, faVideo} from "@fortawesome/pro-regular-svg-icons";
//SOLID
import {
	//faUsers as faUsersSolid,
	faUser as faUserSolid,
	//faCheck,
	//faCogs,
	//faInfoCircle as faInfoCircleSolid,
	//faAngleUp,
	//faAngleDown,
	//faPen,
	//faUserCheck,
	faAlignLeft as faAlignLeftSolid,
	faArrowDown as faArrowDownSolid,
	faArrowRight as faArrowRightSolid,
	faBullseye as faBullseyeSolid,
	faCheckCircle as faCheckCircleSolid,
	faPlusCircle as faPlusCircleSolid,
	faTimes as faTimesSolid,
	faTimesCircle as faTimesCircleSolid,
	faSync as faSyncSolid,
} from "@fortawesome/pro-solid-svg-icons";

//LIGHT
import {
	faMinus as faMinusLight, faPlus as faPlusLight,
} from "@fortawesome/pro-light-svg-icons";

library.add(faFile, faMinusLight, faPlusLight, faPodcast, faVideo, faUserSolid, faAlignLeftSolid, faArrowDownSolid, faArrowRightSolid, faBullseyeSolid, faCheckCircleSolid, faPlusCircleSolid, faTimesSolid, faTimesCircleSolid, faSyncSolid);
